import React from 'react';
import { Issue } from '../types';
import { STATUSES, USERS, LABELS } from '../store';
import { StatusIcon, PriorityIcon } from './icons';
import { format } from 'date-fns';
interface ListViewProps {
  issues: Issue[];
  onIssueClick: (issue: Issue) => void;
}
export function ListView({
  issues,
  onIssueClick
}: ListViewProps) {
  return <div className="flex-1 overflow-y-auto bg-white p-6" data-id="element-129">
      <div className="max-w-[1000px] mx-auto space-y-8" data-id="element-130">
        {STATUSES.map(status => {
        const statusIssues = issues.filter(i => i.status === status.id);
        if (statusIssues.length === 0) return null;
        return <div key={status.id} className="space-y-1.5" data-id="element-131">
              <div className="flex items-center text-[13px] font-medium text-slate-700 mb-2 px-1" data-id="element-132">
                <StatusIcon status={status.id} className="w-4 h-4 mr-2" data-id="element-133" />
                {status.label}
                <span className="ml-2 text-slate-400 font-normal" data-id="element-134">
                  {statusIssues.length}
                </span>
              </div>
              <div className="border border-[#eef0f2] rounded-lg overflow-hidden bg-white shadow-sm" data-id="element-135">
                {statusIssues.map((issue, index) => <IssueRow key={issue.id} issue={issue} onClick={() => onIssueClick(issue)} isLast={index === statusIssues.length - 1} data-id="element-136" />)}
              </div>
            </div>;
      })}
      </div>
    </div>;
}
function IssueRow({
  issue,
  onClick,
  isLast
}: {
  issue: Issue;
  onClick: () => void;
  isLast: boolean;
}) {
  const assignee = USERS.find(u => u.id === issue.assigneeId);
  const labels = issue.labelIds.map(id => LABELS.find(l => l.id === id)).filter(Boolean);
  return <div onClick={onClick} className={`flex items-center px-4 py-2 hover:bg-[#f7f8f9] cursor-pointer transition-colors group ${!isLast ? 'border-b border-[#eef0f2]' : ''}`} data-id="element-137">
      <div className="flex items-center flex-1 min-w-0" data-id="element-138">
        <span className="text-[12px] font-medium text-slate-400 w-16 flex-shrink-0 group-hover:text-slate-500 transition-colors" data-id="element-139">
          {issue.identifier}
        </span>
        <PriorityIcon priority={issue.priority} className="w-3.5 h-3.5 mr-3 flex-shrink-0" data-id="element-140" />
        <span className="text-[13px] font-medium text-slate-900 truncate mr-4" data-id="element-141">
          {issue.title}
        </span>

        <div className="flex items-center space-x-1.5 flex-shrink-0 hidden md:flex" data-id="element-142">
          {labels.map(label => <div key={label?.id} className="flex items-center px-1.5 py-0.5 rounded text-[11px] font-medium border border-slate-200/60 text-slate-600 bg-slate-50/50" data-id="element-143">
              <div className="w-1.5 h-1.5 rounded-full mr-1.5" style={{
            backgroundColor: label?.color
          }} data-id="element-144" />
              {label?.name}
            </div>)}
        </div>
      </div>

      <div className="flex items-center space-x-4 flex-shrink-0 ml-4" data-id="element-145">
        <span className="text-[12px] text-slate-400 hidden sm:block" data-id="element-146">
          {format(new Date(issue.createdAt), 'MMM d')}
        </span>
        {assignee ? <img src={assignee.avatar} alt={assignee.name} className="w-4 h-4 rounded-full border border-slate-200" title={assignee.name} data-id="element-147" /> : <div className="w-4 h-4 rounded-full border border-dashed border-slate-300 flex items-center justify-center" data-id="element-148">
            <span className="text-[8px] text-slate-400" data-id="element-149">?</span>
          </div>}
      </div>
    </div>;
}